import { AllSameKeysEnforcer, AllSameKeyValuesEnforcer } from '../helpers/helpers';
import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, emptyProps, on } from '@ngrx/store';
import { FiltersGroupingUI } from '../../../globals/store/filters-ui.models';
import { eventsActions, WFWorker } from './events.era';
import { FilterGroup, FilterGroupGroups, filterTypes } from '../../../globals/store/filters.data';
import { user } from '@angular/fire/auth';
import { userActions } from './user.era';
import { jsonCopyObject } from 'globals/helpers/helpers';
export { FilterGroup, FilterGroupGroups, filterTypes }


// Definitions
const RESET_ALL_FILTERS = '[Filters] Reset All Filters'
const CLEAR_FILTER_GROUP = '[Filters] Clear Filter Group'
const UPDATE_FILTERS = '[Filters] Update Filters'
const UPDATE_FILTER = '[Filters] Update Filter'
const CHANGE_FILTER_COUNT = '[Filters] Change Filter Count'
const TOGGLE_FILTER_BOOLEAN = '[Filters] Toggle Filter Boolean'
const SET_FILTER_BOOLEAN = '[Filters] Set Filter Boolean'
const LOAD_ONSITE_FILTERS = '[Filters] Load Onsite Filters'
const ADD_ONSITE_FILTER_DATE = '[Filters] Add onsite filter date'
const RESET_ALL_ONSITE_TIMELINE_DATA = '[Filters] RESET ALL ONSITE TIMELINE DATA'
const LOAD_WORKER_SIDEBAR_TASKS = '[Filters] Load Worker Sidebar Tasks'
const SET_TEMP_FILTERS_COUNT_TO_REAL_FILTERS_COUNT = '[Filters] Set Temp Filters Count to real filters count'

// This is defined separately for internal consistency with dictionary making below
export interface FilterGroupTypes {
	programTimeline: FilterGroup
	programTimelineSnapshot: FilterGroup
	programLogistics: FilterGroup
	onsiteTimeline: FilterGroup
	onsiteFacilitators: FilterGroup
  onsiteMySchedule: FilterGroup
  onsiteShare: FilterGroup
  performersTable: FilterGroup
  performerSessionsTable: FilterGroup
  tasks: FilterGroup
  tasksTable: FilterGroup
	tasksCalendar: FilterGroup
  tasksSidebar: FilterGroup
  performerTasks: FilterGroup
  myTasks: FilterGroup
  home: FilterGroup
  publish: FilterGroup
  eventList: FilterGroup
  performerBrief: FilterGroup
  resources: FilterGroup
  sponsors: FilterGroup
  sponsor_sessions: FilterGroup
  exhibitors: FilterGroup
  exhibitor_stands: FilterGroup
  exhibitor_brief: FilterGroup
  taskTime: FilterGroup
  allTasks: FilterGroup
  allTasksCalendar: FilterGroup
  allEventsCalendar: FilterGroup
  allTemplatesTable: FilterGroup
  asset_table: FilterGroup
  quotes: FilterGroup
  accountQuotes: FilterGroup
  programTable: FilterGroup
  budgets: FilterGroup
  appTable: FilterGroup
  app: FilterGroup
  attendees: FilterGroup
}

export interface IToggleFilter {
	condensed: boolean,
	sortByDate: boolean,
	hideCompleted: boolean
}

export interface FiltersState extends FilterGroupTypes {
	tempCounts: AllSameKeysEnforcer<FilterGroupTypes>
	toggleFilters: AllSameKeysEnforcer<FilterGroupTypes>
	lastLoadedFilterUI: { filterGroupType: string, UIModel: FiltersGroupingUI[] } // Please note: this is not meant to be a faithful representation of the current filter UI, as its selected and disabled states are not dispatched through state.  It is meant, instead, to just show the overall model itself.
	onsiteFiltersByDateMap: Record<string, FilterGroup>
	onsiteFilterDates: Set<String>
}



export const filterPageTypes: AllSameKeyValuesEnforcer<FilterGroupTypes> = { home: 'home', onsiteFacilitators: 'onsiteFacilitators', onsiteMySchedule: 'onsiteMySchedule', onsiteShare: 'onsiteShare', programTimeline: 'programTimeline', programLogistics: 'programLogistics', onsiteTimeline: 'onsiteTimeline', tasks: 'tasks', tasksTable:'tasksTable', tasksSidebar: 'tasksSidebar', myTasks: 'myTasks', tasksCalendar: 'tasksCalendar', programTimelineSnapshot: 'programTimelineSnapshot', performersTable: 'performersTable', publish: 'publish', performerSessionsTable: 'performerSessionsTable', exhibitor_brief: 'exhibitor_brief', performerBrief: 'performerBrief', exhibitor_stands: 'exhibitor_stands', sponsors: 'sponsors', sponsor_sessions: 'sponsor_sessions', taskTime: 'taskTime', exhibitors: 'exhibitors', eventList: 'eventList', allTasks: 'allTasks', allTasksCalendar: 'allTasksCalendar', allEventsCalendar: 'allEventsCalendar', performerTasks: 'performerTasks', allTemplatesTable: 'allTemplatesTable', asset_table: 'asset_table', resources: 'resources', quotes: 'quotes', accountQuotes: 'accountQuotes', budgets: 'budgets', programTable: 'programTable', appTable: 'appTable', app: 'app', attendees: 'attendees' }
export type FilterType = keyof typeof filterPageTypes

export const toggleFilterTypes: AllSameKeyValuesEnforcer<IToggleFilter> = { condensed: 'condensed', sortByDate: 'sortByDate', hideCompleted: 'hideCompleted' }

export interface Filter {
	id: string,
	name: string,
	selected: boolean
}

interface IFilterCountChanges {
	Increment
	Decrement
	Set
	Reset
}

export const FilterCountChanges: AllSameKeyValuesEnforcer<IFilterCountChanges> = {
	Increment: 'Increment',
	Decrement: 'Decrement',
	Set: 'Set',
	Reset: 'Reset'
}

export const countFilters = (filters: FilterGroup) => {
	let count = 0
	Object.values(filterTypes).forEach(filterType => {
		switch (filterType) {
			case filterTypes.count:
				break
			case filterTypes.me:
				count += filters.me ? 1 : 0
				break
			case filterTypes.flagged:
				count += filters.flagged ? 1 : 0
        break
      case filterTypes.workforce:
        count += filterTypes.workforce ? 1 : 0
        break
      case filterTypes.closed:
        count += filterTypes.closed ? 1 : 0
        break
      case filterTypes.myEvents:
        count += filters.myEvents ? 1 : 0
        break
      case filterTypes.myResponsibility:
        count += filters.myResponsibility ? 1 : 0
        break
			default:
				count += filters[filterType] ? filters[filterType].length : 0
				break
		}
	})
	return count
}


// Helper Functions
const makeEmptyFilterGroup = (allTasks = false): FilterGroup => !allTasks ? { count: 0 } : { count: 1, me: true, myResponsibility: true }
const makeEmptyCounts = (): AllSameKeysEnforcer<FilterGroupTypes> => ({ programTimeline: 0, programLogistics: 0, onsiteTimeline: 0, tasks: 0, tasksSidebar: 0, myTasks: 0, tasksCalendar: 0, onsiteFacilitators: 0, onsiteMySchedule:0, programTimelineSnapshot: 0, home: 0, tasksTable: 0, performerSessionsTable: 0, performersTable: 0, publish: 0, onsiteShare: 0, performerBrief: 0, sponsors: 0, sponsor_sessions: 0, taskTime: 0, exhibitors: 0, exhibitor_brief: 0, eventList: 0, allTasks: 1, allEventsCalendar: 0, allTasksCalendar: 0, performerTasks: 0, allTemplatesTable: 0, exhibitor_stands: 0, asset_table: 0, resources: 0, quotes: 0, accountQuotes: 0, budgets: 0, programTable: 0, appTable: 0, app: 0, attendees: 0 })
const makeDefaultToggleFilters = (): AllSameKeysEnforcer<IToggleFilter> => ({ condensed: false, sortByDate: false, hideCompleted: false })
const makeAllDefaultToggleFilters = (): AllSameKeysEnforcer<FilterGroupTypes> => Object.assign({}, ...Object.values(filterPageTypes).map(v => ({ [v]: makeDefaultToggleFilters() })))

const initialStateCreator = (): FiltersState => {

	const initialState_obj = {
    asset_table: makeEmptyFilterGroup(),
    quotes: makeEmptyFilterGroup(),
    accountQuotes: makeEmptyFilterGroup(),
    budgets: makeEmptyFilterGroup(),
    home: makeEmptyFilterGroup(),
		programTimeline: makeEmptyFilterGroup(),
		programTimelineSnapshot: makeEmptyFilterGroup(),
		programLogistics: makeEmptyFilterGroup(),
		onsiteTimeline: makeEmptyFilterGroup(),
    onsiteFacilitators: makeEmptyFilterGroup(),
    onsiteMySchedule: makeEmptyFilterGroup(),
    onsiteShare: makeEmptyFilterGroup(),
    tasks: makeEmptyFilterGroup(),
    tasksTable: makeEmptyFilterGroup(),
		tasksSidebar: makeEmptyFilterGroup(),
    tasksCalendar: makeEmptyFilterGroup(),
    myTasks: makeEmptyFilterGroup(),
    performerSessionsTable: makeEmptyFilterGroup(),
    performersTable: makeEmptyFilterGroup(),
    publish: makeEmptyFilterGroup(),
    performerBrief: makeEmptyFilterGroup(),
    resources: makeEmptyFilterGroup(),
    sponsors: makeEmptyFilterGroup(),
    exhibitors: makeEmptyFilterGroup(),
    exhibitor_stands: makeEmptyFilterGroup(),
    sponsor_sessions: makeEmptyFilterGroup(),
    taskTime: makeEmptyFilterGroup(),
    exhibitor_brief: makeEmptyFilterGroup(),
    eventList: makeEmptyFilterGroup(),
    allTasks: makeEmptyFilterGroup(true),
    allTasksCalendar: makeEmptyFilterGroup(),
    allEventsCalendar: makeEmptyFilterGroup(),
    allTemplatesTable: makeEmptyFilterGroup(),
    performerTasks: makeEmptyFilterGroup(),
    programTable: makeEmptyFilterGroup(),
    appTable: makeEmptyFilterGroup(),
    attendees: makeEmptyFilterGroup(),
    app: makeEmptyFilterGroup(),
		tempCounts: makeEmptyCounts(),
    toggleFilters: makeAllDefaultToggleFilters(),
		lastLoadedFilterUI: { UIModel: null, filterGroupType: null },
		onsiteFiltersByDateMap: {},
		onsiteFilterDates: new Set([""]),
	}
	initialState_obj.toggleFilters.tasksCalendar.sortByDate = true
	initialState_obj.toggleFilters.tasksSidebar.condensed = true
	initialState_obj.toggleFilters.tasksSidebar.hideCompleted = true
	return initialState_obj
}


// Actions
export const filterActions = createActionGroup({
	source: 'Filters',
	events: {
		'Reset All Filters': emptyProps(),
		'Clear Filter Group': (payload: keyof FilterGroupTypes) => ({payload}),
		'Update Filters': (payload: { filterGroup: string, filters: FilterGroup }) => payload,
		'Reset All Onsite Timeline Data': emptyProps(),
		'Load Onsite Filters': (payload: FilterGroup) => payload,
		'Add Onsite Date': (payload: string) => ({payload}),
		'Load Worker Sidebar Tasks': (worker: WFWorker) => ({worker}),
		'Set Temp Filters Count to real filters count': (payload: string) => ({payload}),		
		'Toggle Filter Boolean': (payload: { filterGroup: string, booleanFilter: string }) => payload,
		'Set Filter Boolean': (payload: { filterGroup: string, booleanFilter: string, value: boolean }) => payload,
		// V== careful if you decide to use this with onsite filters, will need many changes.  Right now I think it is just being used for additional front page filters
		'Update Filter': (payload: { filterPageType: keyof FilterGroupTypes, filterType: keyof FilterGroup,  value: any }) => payload,
		'Change Filter Count': (payload: { filterGroup: string, changeType: keyof IFilterCountChanges, value?: number }) => payload,
	}
});

// Reducer
export const filterReducer = createReducer(
	initialStateCreator(),
	on(filterActions.resetAllFilters, () => initialStateCreator()),
	on(eventsActions.unloadEvent, () => initialStateCreator()),
	on(userActions.logout, () => initialStateCreator()),
	on(filterActions.resetAllFilters, () => initialStateCreator()),
	on(filterActions.setTempFiltersCountToRealFiltersCount, (state, { payload }) => {
			const tempCount = state[payload].count
			state.tempCounts = {
				...state.tempCounts,
				[payload]: tempCount
			}
			return state
		}
	),
	on(filterActions.updateFilter, (state, { filterPageType, filterType, value }) => {
			return {
				...state,
				[filterPageType]: {
					...state[filterPageType],
					[filterType]: value
				}
			}
		}
	),
	on(filterActions.loadWorkerSidebarTasks, (state, { worker }) => {
			return {
				...state,
				[filterPageTypes.tasksSidebar]: {... makeEmptyFilterGroup(), count: 1, responsibilities: [worker.email] },
				tempCounts: {
					...state.tempCounts,
					[filterPageTypes.tasksSidebar]: 1
				}
			}
		}
	),
	on(filterActions.resetAllOnsiteTimelineData, (state) => {
			return {
				...state,
				[filterPageTypes.onsiteTimeline]: makeEmptyFilterGroup(),
				onsiteFiltersByDateMap: {},
				tempCounts: {
					...state.tempCounts,
					[filterPageTypes.onsiteTimeline]: 0
				}
			}
		}
	),
	on(filterActions.loadOnsiteFilters, (state,  payload ) => {
			return {
				...state,
				[filterPageTypes.onsiteTimeline] : payload,
				tempCounts: {
					...state.tempCounts,
					[filterPageTypes.onsiteTimeline] : payload.count
				}
			}
		}
	),
	on(filterActions.addOnsiteDate, (state, { payload }) => {
			const onsiteFilterDates = new Set(state.onsiteFilterDates)
			onsiteFilterDates.add(payload)
			return {
				...state,
				onsiteFilterDates
			}
		}
	),
	on(filterActions.clearFilterGroup, (state, { payload }) => {
			const tempCounts = {...state.tempCounts, [payload]: 0 }
			return {
				...state,
				[payload]: makeEmptyFilterGroup(payload === 'allTasks'),
				tempCounts
			}
		}
	),
	on(filterActions.changeFilterCount, (state, { filterGroup, changeType, value }) => {
			const tempCounts = { ...state.tempCounts }
			switch (changeType) {
				case FilterCountChanges.Decrement:
					tempCounts[filterGroup]--
					break
				case FilterCountChanges.Increment:
					tempCounts[filterGroup]++
					break
				case FilterCountChanges.Reset:
					tempCounts[filterGroup] = 0
					break
				case FilterCountChanges.Set:
					tempCounts[filterGroup] = value
					break
				default:
					console.log("Unexpected filter count change detected")
			}
			return { ...state, tempCounts }
		}
	),
	on(filterActions.toggleFilterBoolean, (state, { filterGroup, booleanFilter }) => {	
			const toggles = state.toggleFilters[filterGroup]
			toggles[booleanFilter] = !toggles[booleanFilter]
			return {
				...state,
				toggleFilters: {
					...state.toggleFilters,		
					[filterGroup]: { ...toggles }
				}
			}
		}
	),
	on(filterActions.setFilterBoolean, (state, {  filterGroup, booleanFilter, value }) => {	
			const toggles = jsonCopyObject(state.toggleFilters[filterGroup])
			toggles[booleanFilter] = value
			return {
				...state,
				toggleFilters: {
					...state.toggleFilters,		
					[filterGroup]: { ...toggles }
				}
			}
		}
	),
	on(filterActions.updateFilters, (state, {  filterGroup, filters  }) => {
			return {
				...state,
				tempCounts: {
					...state.tempCounts,
					[filterGroup]: filters.count
				},
				[filterGroup]: {
					...filters,
					search: state[filterGroup].search
				}
			}
		}
	),
);

export const filtersFeature = createFeature({
	name: 'filters',
	reducer: filterReducer,
});

export const filterStateSelector = createFeatureSelector<FiltersState>('filters');